module.exports = __webpack_public_path__ + "img/ball2.a02328c4.svg";